/** localStorage that never throws (private windows, blocked storage). Only for conveniences like the last workspace. */
export const prefs = {
  get(key: string): string | null {
    try { return localStorage.getItem(key); } catch { return null; }
  },
  set(key: string, value: string): void {
    try { localStorage.setItem(key, value); } catch { /* ignore */ }
  },
};
